import { Component } from '@angular/core';

@Component({
  selector: 'lib-nec-add-edit-modal-substation',
  templateUrl: './nec-add-edit-modal-substation.component.html',
  styleUrl: './nec-add-edit-modal-substation.component.scss',
  standalone: false
})
export class NecAddEditModalSubstationComponent {

}
